/**
 * Clear expired Auth0 cache so Auth0 SDK doesn't treat user as logged in with stale token.
 * Call before Auth0Provider mounts.
 */
function getIdTokenFromCacheItem(cacheData) {
  if (!cacheData || typeof cacheData !== 'object') return null;
  if (cacheData.id_token && typeof cacheData.id_token === 'string')
    return cacheData.id_token;
  if (
    cacheData.body &&
    cacheData.body.id_token &&
    typeof cacheData.body.id_token === 'string'
  ) {
    return cacheData.body.id_token;
  }
  return null;
}

function isExpired(token) {
  if (!token || typeof token !== 'string') return true;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return true;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    const payload = JSON.parse(json);
    const now = Math.floor(Date.now() / 1000);
    return payload.exp != null && payload.exp < now;
  } catch (e) {
    return true;
  }
}

export function clearExpiredAuthStorage() {
  try {
    Object.keys(localStorage).forEach((key) => {
      if (!key.startsWith('@@auth0spajs@@')) return;
      try {
        const raw = localStorage.getItem(key);
        if (!raw) return;
        const data = JSON.parse(raw);
        const idToken = getIdTokenFromCacheItem(data);
        if (idToken && isExpired(idToken)) {
          localStorage.removeItem(key);
        }
      } catch (e) {
        localStorage.removeItem(key);
      }
    });
    const expiresAt = localStorage.getItem('expiresAt');
    if (expiresAt) {
      try {
        const exp = parseInt(expiresAt, 10);
        const now = Math.floor(Date.now() / 1000);
        if (!isNaN(exp) && exp < now) {
          localStorage.removeItem('idToken');
          localStorage.removeItem('expiresAt');
          localStorage.removeItem('user');
        }
      } catch (e) {
        localStorage.removeItem('idToken');
        localStorage.removeItem('expiresAt');
        localStorage.removeItem('user');
      }
    }
  } catch (e) {
    // ignore
  }
}

export function isTokenExpired(token) {
  return isExpired(token);
}

/** Clear all Auth0 and app auth keys (e.g. when token is expired so user must re-login). */
export function clearAllAuthStorage() {
  try {
    localStorage.removeItem('idToken');
    localStorage.removeItem('expiresAt');
    localStorage.removeItem('user');
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('@@auth0spajs@@')) localStorage.removeItem(key);
    });
  } catch (e) {
    // ignore
  }
}
